"use client";
import { Suspense, useLayoutEffect, useRef } from "react";
import dynamic from "next/dynamic";
import { Box, Stack } from "@mui/material";

import { useStore, observer } from "../../../service/mobx";

const Message = dynamic(() => import("./Message"));
const Typography = dynamic(() => import("@mui/material/Typography"));

function ChatMessages() {
  const { agent } = useStore();
  const ref = useRef();
  const lastMessage = agent.history.at(-1);

  useLayoutEffect(() => {
    if (lastMessage) {
      ref.current.scrollIntoViewIfNeeded();

      const id = setTimeout(() => ref.current.scrollIntoViewIfNeeded(), 300);

      return () => clearTimeout(id);
    }
  }, [lastMessage]);

  return (
    <Stack useFlexGap spacing={6} px={2} height="100%">
      <Suspense>
        {agent.loaded ? (
          agent.history.map((message, index) => (
            <Message
              key={message.userMessage ? index : message.id}
              message={message}
              index={index}
            />
          ))
        ) : (
          <Loader />
        )}
      </Suspense>
      <Box height={80} ref={ref} />
    </Stack>
  );
}

export default observer(ChatMessages);

const Loader = () => (
  <Box
    m="auto"
    display="flex"
    alignItems="center"
    justifyContent="center"
    sx={{
      width: "calc(min(100vw, 100vh) / 3.618)", // Golden ratio for size
      height: "calc(min(100vw, 100vh) / 3.618)", // Maintain a perfect circle
      borderRadius: "50%", // Circular shape
      bgcolor: "var(--surface-inverse-color)", // Dark background
      position: "relative", // Needed for layering
      overflow: "hidden", // Clip shimmer to circle
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "200%", // Ensures smooth transition
        height: "100%",
        background:
          "linear-gradient(90deg, transparent, var(--secondary-color), transparent)", // Wave gradient
        animation: "wave 5s linear 2s infinite" // Animation with delay
      },
      "@keyframes wave": {
        "0%": {
          transform: "translateX(-100%)"
        },
        "40%": {
          transform: "translateX(0%)"
        },
        "80%": {
          transform: "translateX(100%)"
        },
        "100%": {
          transform: "translateX(100%)" // Static for remaining time
        }
      }
    }}
  >
    <Typography
      position="relative" // Keeps it above the wave
      zIndex={1} // Ensure it stays above the animation
      color="var(--surface-inverse-on)" // Text color
      typography="brand" // Use typography styles
      fontSize="calc((min(100vw, 100vh) / 3.618) / 1.618)" // Font proportional to circle size
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      b
    </Typography>
  </Box>
);
